import React from 'react';
import { useForm, ValidationError } from '@formspree/react';
import '../styles/Contact.css';

const translations = {
  en: {
    successTitle: "Thanks for Sending us a Message!",
    successP1: "We will contact you as soon as possible",
    successP2: "or",
    successP3: "send me a Whatsapp here:",
    successButton: "CLICK ME TO SEND MESSAGE",
    title: "Send us your information so we can contact you as soon as possible",
    nameLabel: "Name:",
    emailLabel: "Email:",
    phoneLabel: "Phone:",
    messageLabel: "Message:",
    submitButton: "Send Message",
    sending: "Sending..."
  },
  es: {
    successTitle: "¡Gracias por Enviarnos un Mensaje!",
    successP1: "Nos pondremos en contacto contigo lo antes posible",
    successP2: "o también puedes:",
    successP3: "enviar un Whatsapp aquí:",
    successButton: "HAZ CLIC PARA ENVIAR MENSAJE",
    title: "Envíanos tus datos para que podamos contactarte lo antes posible",
    nameLabel: "Nombre:",
    emailLabel: "Correo Electrónico:",
    phoneLabel: "Teléfono:",
    messageLabel: "Mensaje:",
    submitButton: "Enviar Mensaje",
    sending: "Enviando..."
  }
};

function Contact ({ language }) {
  const [state, handleSubmit] = useForm("mwplrono");
  
  if (state.succeeded) {
    return (
      <div className="contact-page">
        <h2>{translations[language].successTitle}</h2>
        <p>{translations[language].successP1}</p>
        <p>{translations[language].successP2}</p>
        <p>{translations[language].successP3}</p>
        <a href="https://wa.me/529618880654">
          {translations[language].successButton}
        </a>
      </div>
    );
  }

  return (
    <div className="contact-page">
      <h1>{translations[language].title}</h1>
      <div className="contact-container">
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">{translations[language].nameLabel}</label>
            <input
              id="name"
              type="text"
              name="name"
              required
            />
            <ValidationError 
              prefix="Name" 
              field="name"
              errors={state.errors}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">{translations[language].emailLabel}</label>
            <input
              id="email"
              type="email"
              name="email"
              required
            />
            <ValidationError 
              prefix="Email" 
              field="email"
              errors={state.errors}
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">{translations[language].phoneLabel}</label>
            <input
              id="phone"
              type="tel"
              name="phone"
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">{translations[language].messageLabel}</label>
            <textarea
              id="message"
              name="message"
              required
            />
            <ValidationError 
              prefix="Message" 
              field="message"
              errors={state.errors}
            />
          </div>

          <button 
            type="submit" 
            className="submit-btn"
            disabled={state.submitting}
          >
            {state.submitting ? translations[language].sending : translations[language].submitButton}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Contact;